import ES5Functions from './ES5Functions';
import ArrowFunctions from './ArrowFunctions';
import ImpliedReturn from './ImpliedReturn';
import FunctionParenthesisAndParameters from './FunctionParenthesisAndParameters';
function WorkingWithFunctions() {
    return (
        <>
            <ES5Functions />
            <ArrowFunctions />
            <ImpliedReturn />
            <FunctionParenthesisAndParameters />
        </>
    );
}

export default WorkingWithFunctions;